import { QuestionCircleOutlined } from '@ant-design/icons';

import { SidebarBanner } from '@app/shared/components/SidebarBanner';

import type { FC } from 'react';

interface HelpBannerProps {
  onClick: () => void;
  isSmall?: boolean;
}

export const HelpBanner: FC<HelpBannerProps> = ({ onClick, isSmall }) => (
  <SidebarBanner
    variant="primary"
    icon={<QuestionCircleOutlined />}
    title="Помощь"
    subtitle="Поддержка и база знаний"
    isSmall={isSmall}
    dataTestId="help-banner"
    onClick={onClick}
  />
);
